import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2a91ec5c")

_pushScopeId("data-v-2a91ec5c")
const _hoisted_1 = { class: "content-container" }
const _hoisted_2 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BalIcon = _resolveComponent("BalIcon")

  return (_openBlock(), _createBlock("div", {
    class: ['bal-chip', _ctx.classes]
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.label)
        ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true),
      (_ctx.closeable)
        ? (_openBlock(), _createBlock("div", {
            key: 2,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closed')))
          }, [
            _createVNode(_component_BalIcon, {
              name: "x",
              size: _ctx.iconSize,
              class: ['close', _ctx.iconClasses]
            }, null, 8, ["size", "class"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
})